import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const entityCardPulse: ExtensionDefinition = EntityCardBlueprint.make({
  name: 'card',
  params: {
    loader: async () =>
      import('./entity-card-pulse').then(m => <m.EntityCardPulse />),
  },
});
